import VectorProps from "./VectorProps";

export default function Dashboard(props: VectorProps) {
  const {
    className = "",
    fill = "currentColor",
    handleClick = () => null,
    height,
    width,
  } = props;
  // from https://www.figma.com/file/LyX9wbSKd81UvXFeq58wMx/Foodsteps-Rebrand-Design-Library?type=design&node-id=1501-1661&mode=design&t=djPELc7GvHaLzkcp-0
  return (
    <svg
      className={className}
      fill={fill}
      height={height ?? width}
      onClick={handleClick}
      viewBox="0 0 20 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3883_2337)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 1.6H2C1.77909 1.6 1.6 1.77909 1.6 2V7C1.6 7.22091 1.77909 7.4 2 7.4H7C7.22091 7.4 7.4 7.22091 7.4 7V2C7.4 1.77909 7.22091 1.6 7 1.6ZM2 0C0.895431 0 0 0.89543 0 2V7C0 8.10457 0.89543 9 2 9H7C8.10457 9 9 8.10457 9 7V2C9 0.895431 8.10457 0 7 0H2Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 12.6H2C1.77909 12.6 1.6 12.7791 1.6 13V18C1.6 18.2209 1.77909 18.4 2 18.4H7C7.22091 18.4 7.4 18.2209 7.4 18V13C7.4 12.7791 7.22091 12.6 7 12.6ZM2 11C0.895431 11 0 11.8954 0 13V18C0 19.1046 0.89543 20 2 20H7C8.10457 20 9 19.1046 9 18V13C9 11.8954 8.10457 11 7 11H2Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 1.6H13C12.7791 1.6 12.6 1.77909 12.6 2V7C12.6 7.22091 12.7791 7.4 13 7.4H18C18.2209 7.4 18.4 7.22091 18.4 7V2C18.4 1.77909 18.2209 1.6 18 1.6ZM13 0C11.8954 0 11 0.89543 11 2V7C11 8.10457 11.8954 9 13 9H18C19.1046 9 20 8.10457 20 7V2C20 0.895431 19.1046 0 18 0H13Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 12.6H13C12.7791 12.6 12.6 12.7791 12.6 13V18C12.6 18.2209 12.7791 18.4 13 18.4H18C18.2209 18.4 18.4 18.2209 18.4 18V13C18.4 12.7791 18.2209 12.6 18 12.6ZM13 11C11.8954 11 11 11.8954 11 13V18C11 19.1046 11.8954 20 13 20H18C19.1046 20 20 19.1046 20 18V13C20 11.8954 19.1046 11 18 11H13Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_3883_2337">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
